import { useContext } from 'react';
import { StoresContext } from '../../../App';

const features = {
    Wholesale: 'Офис продаж',
    WebStore: 'Интернет магазин',
    Retail: 'Розничный магазин',
    Designer: 'Проектирование',
    PanelAssembly: 'Монтаж',
    Service: 'Сервис',
    '': 'Все',
};

export default function FeatureFilters() {
    const { featureFilters, setFeatureFilters } = useContext(StoresContext);
    const selectedFeature = (featureFilters[0]?.code as keyof typeof features) || '';
    return (
        <div className="tabs-swiper tabs-swiper--horizontal swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events swiper-container-free-mode">
            <div className="swiper-wrapper mn-type-filters" aria-live="polite">
                {Object.entries(features).map(([code, name]) => (
                    <div
                        key={code}
                        className="swiper-slide swiper-slide-active"
                        role="group"
                        onClick={() => setFeatureFilters(code ? [{ code, value: null }] : [])}
                    >
                        <span
                            className={
                                'tabs-swiper__item type-filter js-mn-filter-type mn-type-filter mn-type-filter--2' +
                                (selectedFeature === code ? ' active' : '')
                            }
                        >
                            {name}
                        </span>
                    </div>
                ))}
            </div>
            <div
                className="swiper-button-prev tabs-swiper__btn-prev swiper-button-disabled"
                tabIndex={-1}
                role="button"
                aria-label="Previous slide"
                aria-controls="swiper-wrapper-d8cc910dbf4b42410e"
                aria-disabled="true"
            >
                <svg
                    className="icon"
                    width="12"
                    height="18"
                    viewBox="0 0 12 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M10 16.37L2 9l8-7.369" stroke="#000" strokeWidth="2" strokeLinecap="square" />
                </svg>
            </div>
            <div
                className="swiper-button-next tabs-swiper__btn-next"
                tabIndex={0}
                role="button"
                aria-label="Next slide"
                aria-controls="swiper-wrapper-d8cc910dbf4b42410e"
                aria-disabled="false"
            >
                <svg
                    className="icon"
                    width="12"
                    height="18"
                    viewBox="0 0 12 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M10 16.37L2 9l8-7.369" stroke="#000" strokeWidth="2" strokeLinecap="square" />
                </svg>
            </div>
            <span className="swiper-notification" aria-live="assertive" aria-atomic="true" />
            <span className="swiper-notification" aria-live="assertive" aria-atomic="true" />
        </div>
    );
}
